import { render, staticRenderFns } from "./ModernTable.vue?vue&type=template&id=39f2d764&scoped=true&"
import script from "./ModernTable.vue?vue&type=script&lang=js&"
export * from "./ModernTable.vue?vue&type=script&lang=js&"
import style0 from "./ModernTable.vue?vue&type=style&index=0&id=39f2d764&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f2d764",
  null
  
)

export default component.exports